import React from "react";

/**
 * Switches the video comparison between alternating auto-play and hover-to-play.
 */
const PlaybackModeToggle = ({ autoAlternate, hasStarted, onToggle }) => (
  <div className="playback-mode">
    <button
      type="button"
      role="switch"
      aria-checked={autoAlternate}
      className={`playback-switch${autoAlternate ? " is-on" : ""}`}
      onClick={onToggle}
    >
      <span className="playback-switch-track">
        <span className="playback-switch-knob" />
      </span>
      <span className="playback-switch-text">Auto-play, alternating</span>
    </button>
    <span className="playback-mode-hint">
      {autoAlternate
        ? "Left plays, then right, then left again"
        : hasStarted
        ? "Hover a video to play it"
        : "Click a video to start, then hover either side to play it"}
    </span>
  </div>
);

export default PlaybackModeToggle;
